import Axios from "axios";
import { getFingerprint } from './fingerprint';
import { v4 as uuidv4 } from 'uuid';

getFingerprint().then(res => {
    sessionStorage.setItem('xFpId', res);
})
sessionStorage.setItem('xTxnId', "cidm-cli-" + uuidv4())

Axios.defaults.headers['x-fp-id'] = sessionStorage.getItem("xFpId");
Axios.defaults.headers['x-txn-id'] = sessionStorage.getItem("xTxnId");
Axios.defaults.withCredentials = true;

export default Axios;